import {FeatureCollection, MultiPolygon} from '@turf/turf';
import {Point} from 'jspdf';
import L from 'leaflet';
import {LeafletMapLayer} from '../classes/leaflet-map-layer';
import {LeafletVectortileSource} from '../classes/leaflet-vectortile-source';
import {Mapster} from '../classes/mapster';
import {LeafletTileSource} from '../classes/leaflet-tile-source';

export class MapsterTileSource extends LeafletTileSource {
    public proxyUrl = '/api/mapster/';
    public imageId: string;

    constructor(imageId: string, layerInfo: LeafletMapLayer) {
        super(new LeafletMapLayer(layerInfo).setUiHandle(`mapsterImage-${imageId}`));

        this.imageId = imageId;
        this.url = `/api/mapster/tile-layer/${imageId}/{z}/{x}/{y}`;
    }
}
